import React, {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import EstadoOS from "./estadoOS";
import MaterialTable from "material-table";
import {tableIcons} from "../../../utils/utils";
import {convertISODateTimeToBRLocale} from "../../../common/Util";

const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
}));


const ListaOS = ({
                     listaOrdensServico
                          }) => {
    const classes = useStyles();

    const pneusNaCasa = useSelector( state => state.i4.pneusNaCasa);

    const clickNewTab  = (url) => {
        const win = window.open(`${url}`, "_blank");
        win.focus();
    }

    let filtroEtapa = {};
    let filtroSituacao = {};



    pneusNaCasa.map( p =>{
        if (!filtroEtapa[p.etapa]) { filtroEtapa[p.etapa] = p.etapa;  }
        if (!filtroSituacao[p.situacao]) { filtroSituacao[p.situacao] = p.situacao;  }
    });


    const getColumns = () => {
        return(
             [
                {
                    title: 'id',
                    field: 'id',
                    editable: 'never',
                    hidden: true
                },

                {
                    title: 'Ordem Serviço',
                    field: 'ordemServicoId',
                    editable: 'never',
                },
                 {
                     title: 'Chegada',
                     field: 'DTChegada',
                     editable: 'never',
                     render: row => convertISODateTimeToBRLocale(row.DTChegada)
                 },
                 {
                     title: 'Inicio',
                     field: 'DTInicioProducao',
                     editable: 'never',
                     render: row => convertISODateTimeToBRLocale(row.DTInicioProducao)
                 },
                 {
                     title: 'Fim Produção',
                     field: 'DTFimProducao',
                     editable: 'never',
                     render: row => convertISODateTimeToBRLocale(row.DTFimProducao)
                 },


                 {
                     title: 'Cliente',
                     field: 'cliente',
                     editable: 'never',
                 },
                 {
                     title: 'Processo',
                     field: 'processo',
                     editable: 'never',
                 },

                 {
                     title: 'Etapa',
                     field: 'etapaAtual',
                     editable: 'never',
                     hidden: true
                 },
                 {
                     title: 'Etapa',
                     field: 'etapa',
                     editable: 'never',
                     lookup: filtroEtapa
                 },
                 {
                     title: 'Dt Etapa',
                     field: 'DTUltimaEtapa',
                     editable: 'never',
                     render: row => convertISODateTimeToBRLocale(row.DTUltimaEtapa)
                 },
                 {
                     title: '# Etapas',
                     field: 'NumEtapas',
                     editable: 'never',
                 },

                 {
                     title: 'Prioridade',
                     field: 'prioridade',
                     editable: 'never',
                 },
                 {
                     title: 'Situacao',
                     field: 'situacao',
                     editable: 'never',
                     lookup: filtroSituacao
                 },
                 {
                     title: 'Banda Solicitada',
                     field: 'bandaSolicitada',
                     editable: 'never',

                 },
                 {
                     title: 'Banda Aplicada',
                     field: 'itemBandaAplicada',
                     editable: 'never',

                 },
                 {
                     title: 'Dot',
                     field: 'dot',
                     editable: 'never'
                 },
                 {
                     title: 'MarcaFogo',
                     field: 'marcaFogo',
                     editable: 'never'
                 },
                {
                    title: 'Fabricante',
                    field: 'fabricante',
                    editable: 'never'
                },

                {
                    title: 'Modelo',
                    field: 'modelo',
                    editable: 'never'
                },
                {
                    title: 'Medida',
                    field: 'medida',
                    editable: 'never'
                }



            ]);
    }


   // console.log("pneus em casa", pneusNaCasa);
    const titulo = "PNEUS EM CASA - TOTAL"

    return (
        <React.Fragment>
            <Grid>
                <Paper>
                    <MaterialTable
                        icons={tableIcons}
                        title={titulo}
                        columns={getColumns()}
                        data={pneusNaCasa}
                        onRowClick={(event, rowData, togglePanel) => clickNewTab(`/ordemServico/${rowData.ordemServicoId}`)}
                        options={{
                            filtering: true,
                            pageSize: 100,
                            pageSizeOptions: [25,50,100, 200, { value: pneusNaCasa.length +2, label: 'All' }],
                            addRowPosition: 'first'
                        }}





                    />
                </Paper>
            </Grid>
        </React.Fragment>
    )

}

export default ListaOS;
